import {
  Box,
  Chip,
  FormControl,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ChipBtn from "../../UI/Chip/Chip";
import { useNavigate } from "react-router-dom";
import { TermsModal } from "./TermsModal";
import PrivacyModal from "./PrivacyModal";

const textField = {
  backgroundColor: "#fff",
  borderRadius: "6px",
  "& .MuiFilledInput-root": {
    borderRadius: "6px",
  },
  "& input": {
    backgroundColor: "#fff",
    padding: "8px",
    borderRadius: "6px",
    border: "1px solid #D8D8D8",
  },
};

const Subscribe = () => {
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [openTermsModal, setOpenTermsModal] = useState(false);
  const [acceptedPrivacy, setAcceptedPrivacy] = useState(false);
  const [openPrivacyModal, setOpenPrivacyModal] = useState(false);

  const [subscribeData, setSubscribeData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    userId: "",
    password: "",
    password2: "",
    country: "",
    company: "",
    occupation: "",
  });

  const [errors, setErrors] = useState({});
  const [enableSubscribe, setEnableSubscribe] = useState(true);
  const navigate = useNavigate();

  const smallerThan900 = useMediaQuery("(min-width:900px");

  useEffect(() => {
    if (acceptedTerms && acceptedPrivacy && validate()) {
      setEnableSubscribe(true);
    } else {
      setEnableSubscribe(false);
    }
  }, [acceptedTerms, acceptedPrivacy, subscribeData]);
  const acceptTermsHandler = () => {
    setAcceptedTerms(true);
  };

  const openTermsModalHandler = () => {
    setOpenTermsModal(true);
  };

  const closeTermsModalHandler = () => {
    setOpenTermsModal(false);
  };

  const acceptPrivacyHandler = () => {
    setAcceptedPrivacy(true);
  };

  const openPrivacyModalHandler = () => {
    setOpenPrivacyModal(true);
  };

  const closePrivacyModalHandler = () => {
    setOpenPrivacyModal(false);
  };

  const setInputHandler = (e) => {
    const { name, value } = e.target;
    setSubscribeData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const validate = () => {
    let tempErrors = {};
    if (!subscribeData.firstName)
      tempErrors.firstName = "First Name is required.";
    if (!subscribeData.lastName) tempErrors.lastName = "Last Name is required.";
    if (!subscribeData.email || !subscribeData.email.includes("@"))
      tempErrors.email = "Please enter a valid email address.";
    if (!subscribeData.userId) tempErrors.userId = "User ID is required.";
    if (!subscribeData.password) tempErrors.password = "Password is required.";
    if (subscribeData.password !== subscribeData.password2)
      tempErrors.password2 = "Passwords do not match.";
    if (!subscribeData.country) tempErrors.country = "Country is required.";
    if (!subscribeData.occupation)
      tempErrors.occupation = "Occupation is required.";
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (lookUpKey) => {
    if (!validate()) return;

    const data = { ...subscribeData, lookUpKey };

    const { password2, ...filtered_data } = data;

    const formBody = Object.keys(filtered_data)
      .map(
        (key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
      )
      .join("&");

    try {
      let url = "https://rawdat.ai/subscribe/purchase-request-submission";
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formBody,
      });

      if (response.ok) {
        navigate("/confirmation");
      } else {
        console.error("Failed to subscribe:", response.statusText);
      }
    } catch (error) {
      console.error("Error during subscription:", error);
    }
  };
  return (
    <Box
      sx={{
        marginLeft: "auto",
        marginRight: "auto",
        marginBottom: "4rem",
        display: "flex",
        flexDirection: smallerThan900 ? "row" : "column",
        gap: smallerThan900 ? "4rem" : "0.5rem",
        maxWidth: "1060px",
        justifyContent: "center",
        width: "80vw",
      }}
    >
      <TermsModal
        open={openTermsModal}
        onClose={closeTermsModalHandler}
        acceptTermsHandler={acceptTermsHandler}
        acceptedTerms={acceptedTerms}
      />

      <PrivacyModal
        open={openPrivacyModal}
        onClose={closePrivacyModalHandler}
        acceptPrivacyHandler={acceptPrivacyHandler}
      />

      <Box
        sx={{
          width: smallerThan900 ? "50%" : "90%",
          marginTop: "80px",
          display: "flex",
          gap: "2rem",
          flexDirection: "column",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <Typography variant={"h4"} sx={{ color: "titleColor.main" }}>
          Create your profile
        </Typography>

        <Box display={"flex"} gap={4} flexDirection={"column"}>
          <Box display={"flex"} gap={2} flexDirection={"column"}>
            <Typography variant="body1">First Name*</Typography>
            <TextField
              sx={textField}
              name="firstName"
              size="small"
              variant="filled"
              InputProps={{ disableUnderline: true }}
              onChange={setInputHandler}
              error={!!errors.firstName}
              helperText={errors.firstName}
              required
            />
          </Box>

          <Box display={"flex"} gap={2} flexDirection={"column"}>
            <Typography variant="body1">Last Name*</Typography>
            <TextField
              sx={textField}
              name="lastName"
              size="small"
              variant="filled"
              InputProps={{ disableUnderline: true }}
              onChange={setInputHandler}
              error={!!errors.lastName}
              helperText={errors.lastName}
              required
            />
          </Box>

          <Box display={"flex"} gap={2} flexDirection={"column"}>
            <Typography variant="body1">Email*</Typography>
            <TextField
              sx={textField}
              type="email"
              name="email"
              size="small"
              variant="filled"
              InputProps={{ disableUnderline: true }}
              onChange={setInputHandler}
              error={!!errors.email}
              helperText={errors.email}
              required
            />
          </Box>

          <Box display={"flex"} gap={2} flexDirection={"column"}>
            <Typography variant="body1">User ID*</Typography>
            <TextField
              sx={textField}
              name="userId"
              size="small"
              variant="filled"
              InputProps={{ disableUnderline: true }}
              onChange={setInputHandler}
              error={!!errors.userId}
              helperText={errors.userId}
              required
            />
          </Box>

          <Box display={"flex"} gap={2} flexDirection={"column"}>
            <Typography variant="body1">Password*</Typography>
            <TextField
              type="password"
              sx={textField}
              name="password"
              size="small"
              variant="filled"
              InputProps={{ disableUnderline: true }}
              onChange={setInputHandler}
              error={!!errors.password}
              helperText={errors.password}
              required
            />
          </Box>

          <Box display={"flex"} gap={2} flexDirection={"column"}>
            <Typography variant="body1">Confirm Password*</Typography>
            <TextField
              type="password"
              sx={textField}
              name="password2"
              size="small"
              variant="filled"
              InputProps={{ disableUnderline: true }}
              onChange={setInputHandler}
              error={!!errors.password2}
              helperText={errors.password2}
              required
            />
          </Box>

          <Box display={"flex"} gap={2} flexDirection={"column"}>
            <Typography variant="body1">Country*</Typography>
            <TextField
              sx={textField}
              name="country"
              size="small"
              variant="filled"
              InputProps={{ disableUnderline: true }}
              onChange={setInputHandler}
              error={!!errors.country}
              helperText={errors.country}
              required
            />
          </Box>

          <Box display={"flex"} gap={2} flexDirection={"column"}>
            <Typography variant="body1">Occupation*</Typography>
            <TextField
              sx={textField}
              name="occupation"
              size="small"
              variant="filled"
              InputProps={{ disableUnderline: true }}
              onChange={setInputHandler}
              error={!!errors.occupation}
              helperText={errors.occupation}
              required
            />
          </Box>

          <Box display={"flex"} gap={2} flexDirection={"column"}>
            <Typography variant="body1">
              Company{" "}
              <span style={{ fontFamily: "Roboto", color: "#888" }}>
                (optional)
              </span>
            </Typography>
            <TextField
              sx={textField}
              name="company"
              size="small"
              variant="filled"
              InputProps={{ disableUnderline: true }}
              onChange={setInputHandler}
              required
            />
          </Box>

          <Box
            mt={2}
            display={"flex"}
            flexDirection={"column"}
            gap={2}
            alignItems={"center"}
          >
            <Typography variant="body1">
              Read and accept Terms of use and our Privacy policy.
            </Typography>

            {!acceptedTerms ? (
              <Chip
                color="primary"
                label={"Terms of use"}
                variant={"filled"}
                onClick={openTermsModalHandler}
                sx={{ width: "100%", fontSize: "14px", padding: "10px 24px" }}
              />
            ) : (
              <Chip
                color="success"
                label={<> &#x2713; Terms of use accepted</>}
                variant={"filled"}
                sx={{ width: "100%", fontSize: "14px", padding: "10px 24px" }}
              />
            )}

            {!acceptedPrivacy ? (
              <Chip
                variant="filled"
                color="primary"
                onClick={openPrivacyModalHandler}
                label={"Privacy policy"}
                sx={{ width: "100%", fontSize: "14px", padding: "10px 24px" }}
              />
            ) : (
              <Chip
                variant="filled"
                color="success"
                label={<>&#x2713; Privacy Policy accepted</>}
                sx={{ width: "100%", fontSize: "14px", padding: "10px 24px" }}
              />
            )}
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          width: smallerThan900 ? "50%" : "100%",
          marginTop: smallerThan900 ? "80px" : "40px",
          display: "flex",
          gap: "2rem",
          flexDirection: "column",
        }}
      >
        <Typography variant={"h4"} sx={{ color: "titleColor.main" }}>
          Select a plan
        </Typography>

        <Box display={"flex"} gap={2} flexDirection={"column"}>
          <Box
            padding={"31px 34px"}
            sx={{
              borderRadius: "10px",
              border: "1px solid #d8d8d8",
              width: smallerThan900 ? "400px" : "100%",
              display: "flex",
              flexDirection: "column",
              gap: "0.75rem",
            }}
          >
            <Typography variant="h6">MONTHLY SUBSCRIPTION</Typography>
            <Typography variant="h4">
              $49.99{" "}
              <span style={{ fontFamily: "Roboto", fontSize: "1rem" }}>
                per month
              </span>
            </Typography>
            <Typography variant="body1" sx={{ marginBottom: "1rem" }}>
              No commitment. Cancel anytime.
            </Typography>
            <Chip
              label="Subscribe"
              variant={"filled"}
              sx={{
                width: "100px",
                padding: 0,
                "& .MuiChip-label": { fontSize: "14px" },
              }}
              color={"primary"}
              disabled={
                !acceptedTerms ||
                !acceptedPrivacy ||
                Object.keys(errors).length > 0
              }
              onClick={() => {
                handleSubmit("doi7-ggjff-44kfkjfdi-sssddd-sskiool");
              }}
            />
          </Box>

          <Box
            padding={"31px 34px"}
            sx={{
              borderRadius: "10px",
              border: "1px solid #d8d8d8",
              width: smallerThan900 ? "400px" : "100%",
              display: "flex",
              flexDirection: "column",
              gap: "0.75rem",
            }}
          >
            <Typography variant="h6">6 - MONTHS SUBSCRIPTION</Typography>
            <Typography variant="h4">
              $254.95{" "}
              <span style={{ fontFamily: "Roboto", fontSize: "1rem" }}>
                (Save 15% less)
              </span>
            </Typography>

            <Chip
              label="Subscribe"
              variant={"filled"}
              sx={{
                width: "100px",
                padding: 0,
                "& .MuiChip-label": { fontSize: "14px" },
              }}
              color={"primary"}
              disabled={
                !acceptedTerms ||
                !acceptedPrivacy ||
                Object.keys(errors).length > 0
              }
              onClick={() => {
                handleSubmit("doi7-ggjff-44kfkjfdi-sssddd-7aaoi3l");
              }}
            />
          </Box>

          <Box
            padding={"31px 34px"}
            sx={{
              borderRadius: "10px",
              border: "1px solid #d8d8d8",
              width: smallerThan900 ? "400px" : "100%",
              display: "flex",
              flexDirection: "column",
              gap: "0.75rem",
            }}
          >
            <Typography variant="h6">1-YEAR SUBSCRIPTION</Typography>
            <Typography variant="h4">
              $449.91{" "}
              <span style={{ fontFamily: "Roboto", fontSize: "1rem" }}>
                (Save 25% less)
              </span>
            </Typography>

            <Chip
              label="Subscribe"
              variant={"filled"}
              sx={{
                width: "100px",
                padding: 0,
                "& .MuiChip-label": { fontSize: "14px" },
              }}
              color={"primary"}
              disabled={
                !acceptedTerms ||
                !acceptedPrivacy ||
                Object.keys(errors).length > 0
              }
              onClick={() => {
                handleSubmit("doi7-ggjff-44kfkjfdi-sssddd-0aas09dl");
              }}
            />
          </Box>

          <Typography variant="body1" sx={{ fontSize: "18px" }}>
            If you have an account ...{" "}
            <span
              style={{
                fontFamily: "Roboto",
                textDecoration: "underline",
                color: "#0071ba",
                cursor: "pointer",
                fontSize: "18px",
              }}
              onClick={() => navigate("/login")}
            >
              log in
            </span>
            .
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Subscribe;
